import { render, staticRenderFns } from "./ServicesByHome.vue?vue&type=template&id=1ffb2ef2&scoped=true"
import script from "./ServicesByHome.vue?vue&type=script&lang=js"
export * from "./ServicesByHome.vue?vue&type=script&lang=js"
import style0 from "./ServicesByHome.vue?vue&type=style&index=0&id=1ffb2ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb2ef2",
  null
  
)

export default component.exports